import { useContext, useState, useEffect } from 'react';
import close from '../../asset/images/btn/icon_x.png';
import UrlContext from '../common/UrlContext';
import HeadTitle from '../common/headTitle';
import Pagination from '../pagination/Pagination.js';

function Product() {
  const BASE_URL = useContext(UrlContext) + `product`;
  const BLOCK_SIZE = 10;

  const [page, setPage] = useState({});
  const [no, setNo] = useState(1);

  const [postList, setPostList] = useState([]);
  const [post, setPost] = useState({});
  const [isLayer, setIsLayer] = useState(false);

  useEffect(() => {
    getPostList();
  }, [no]);

  const getPostList = () => {
    fetch(`${BASE_URL}/all?page=${no}&size=${BLOCK_SIZE}`, {
       method: 'GET',
       headers: {
        'Content-Type': 'application/json',
       }
     })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then((data) => {
        if (data !== undefined && data.code !== undefined && data.code === '200') {
          setPage(data.page);
          setPostList(data.data);
        }
      });
  };

  const showLayer = (e) => {
    e.preventDefault();
    setPost({});
    setIsLayer(true);
  };

  const closeLayer = (e) => {
    e.preventDefault();
    setIsLayer(false);
  };

  const save = () => {
    console.log(post);

    fetch(`${BASE_URL}/save`, {
      method: 'POST',
      body: JSON.stringify(post),
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then((data) => {
        console.log(data);
        if (data !== undefined && data.code !== undefined && data.code === '200') {
          const dataKey = data.data.prodCode;
          const postKey = postList.findIndex(list => list.prodCode === dataKey);

          if (postKey !== -1) {
            setPostList(
              postList.map(list =>
                list.prodCode !== dataKey ? list : data.data
              )
            );
          } else {
            setPostList(post => [...post, data.data]);
          }

          setIsLayer(false);
        } else {
          alert(data.codeMsg);
        }
      });
  };

  const edit = (data) => {
    setPost(data);
    setIsLayer(true);
  };

  const writeInput = (e) => {
    const { name, value } = e.target;
    setPost({ ...post, [name]: value });
  };

  const remove = (key) => {
    if (key !== undefined && key.length > 0 && window.confirm('상품 정보를 삭제하시겠습니까?') === true) {
      fetch(`${BASE_URL}/delete/${key}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw response;
        })
        .then((data) => {
          if (data !== undefined && data.code !== undefined && data.code === '200') {
            console.log(data);
            setPostList(postList.filter(post => post.prodCode !== key));
          } else {
            alert(data.codeMsg);
          }
        });
    }
  };

  return (
    <div id="container" className="container">
      <div id="contents" className="cont">
        <div className="section">
          <div className="sectionin">
            <HeadTitle project="yakgorithm" title="제품"/>
            <div className="subst">
              <div className="d_table">
                <table className="dtable" summary="제품 목록 입니다.">
                  <caption>제품 목록</caption>
                  <colgroup>
                    <col width="80" />
                    <col width="*" />
                    <col width="140" />
                    <col width="80" />
                    <col width="100" />
                    <col width="80" />
                    <col width="100" />
                    <col width="140" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">상품코드</th>
                      <th scope="col">상품명</th>
                      <th scope="col">상품규격</th>
                      <th scope="col">단위수량</th>
                      <th scope="col">권장소비자가격</th>
                      <th scope="col">과세여부</th>
                      <th scope="col">카테고리번호</th>
                      <th scope="col">변경</th>
                    </tr>
                  </thead>
                  <tbody>
                    {postList.map(post => (
                      <tr key={post.prodCode} className="ov">
                        <td>{post.prodCode}</td>
                        <td>{post.prodName}</td>
                        <td>{post.prodSize}</td>
                        <td>{post.quantity}</td>
                        <td>{post.price}</td>
                        <td>{post.tax}</td>
                        <td>{post.no}</td>
                        <td>
                          <button onClick={() => edit(post)} className="tbbtn btprimary">수정</button>
                          <button onClick={() => remove(post.prodCode)} className="tbbtn btblack">삭제</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="bbtn">
                <p className="bfr"><button onClick={showLayer} className="btprimary">등록</button></p>
              </div>
              <Pagination pageNo={no} setNo={setNo} pageTotal={page.total} pageSize={BLOCK_SIZE}></Pagination>
              {isLayer === true ? (
              <div className="layerpop">
                <div className="layttl">
                  <p>약품 상세 정보</p>
                  <button onClick={closeLayer} className="layclosebtn" type="button"><img src={close} alt="레이어 닫기"/></button>
                </div>
                <div className="layerpopin">
                  <div className="dv_table w100">
                    <form>
                      <table className="dvtable" summary="약품 상세 정보 입니다.">
                      <caption>약품 상세 정보</caption>
                      <colgroup>
                        <col width="135" />
                        <col width="*" />
                        <col width="135" />
                        <col width="*" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <th>인덱스</th>
                          <td colSpan="3">
                            <p className="pl6">
                              <input readOnly onChange={writeInput} value={post.idx || ''} name="idx" style={{ width: '300px' }} type="text" className="inp read" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>상품코드</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.prodCode || ''} name="prodCode" type="text" className="inp" />
                            </p>
                          </td>
                          <th>필수지정기호</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.essentialMark || ''} name="essentialMark" type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>상품명</th>
                          <td colSpan="3">
                            <p className="pl6">
                              <input onChange={writeInput} value={post.prodName || ''} name="prodName" style={{ width: '300px' }} type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>상품규격</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.prodSize || ''} name="prodSize" type="text" className="inp" />
                            </p>
                          </td>
                          <th>단위수량</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.quantity || ''} name="quantity" type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>표준바코드</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.barcode || ''} name="barcode" type="text" className="inp" />
                            </p>
                          </td>
                          <th>상품구분</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.classification || ''} name="classification" type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>권장소비자가격</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.price || ''} name="price" type="text" className="inp" />
                            </p>
                          </td>
                          <th>보험코드</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.insurance || ''} name="insurance" type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>주문최소수량</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.minOrder || ''} name="minOrder" type="text" className="inp" />
                            </p>
                          </td>
                          <th>주문최대수량</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.maxOrder || ''} name="maxOrder" type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>과세여부</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.tax || ''} name="tax" type="text" className="inp" />
                            </p>
                          </td>
                          <th>카테고리번호</th>
                          <td>
                            <p className="pl6">
                              <input onChange={writeInput} value={post.no || ''} name="no" type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <th>소분류</th>
                          <td colSpan="3">
                            <p className="pl6">
                              <input onChange={writeInput} value={post.smallClassification || ''} name="smallClassification" style={{ width: '300px' }} type="text" className="inp" />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      </table>
                    </form>
                  </div>
                  <div className="laybtn pt25">
                    <button onClick={closeLayer} className="btblack">닫기</button>
                    <button onClick={save} className="btprimary">저장</button>
                  </div>
                </div>
              </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;